///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';
import { AbstractDialogManager } from '../../../dialog-manager/abstract-dialog-manager';
import { UpdateEulaDialogComponent } from './update-eula-dialog.component';

@Component({
    selector: 'winde-update-eula-dialog-wrapper-component',
    template: ''
})
export class UpdateEulaDialogWrapperComponent extends AbstractDialogManager<unknown, UpdateEulaDialogComponent> {
    constructor() {
        super(UpdateEulaDialogComponent);
        this.openDialog();
    }

    preparingBaseConfig(): void {
        this.baseConfig.width = '600px';
        this.baseConfig.height = '450px';
        this.baseConfig.position = { top: '30px' };
        this.baseConfig.disableClose = true;
    }
}
